module.exports = __webpack_public_path__ + "static/media/team-01.dd22906b.jpg";